import imageOne from '@/assets/images/cities/kitchener1.jpg'
import imageTwo from '@/assets/images/cities/kitchener2.jpg'
import imageThree from '@/assets/images/cities/kitchener3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Kitchener',
  writeup: '',
  website: 'KitchenerNotaryPublic.com',
  url: 'https://www.kitchenernotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(226) 214-4911',
      hours: {
        monday: '9:00AM to 5:00PM',
        tuesday: '9:00AM to 5:00PM',
        wednesday: '9:00AM to 5:00PM',
        thursday: '9:00AM to 5:00PM',
        friday: '9:00AM to 5:00PM',
        saturday: '',
        sunday: ''
      },
      address: 'Victoria Street South Location',
      notes: 'No Power of Attorneys.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontario/cities/kitchener.js